import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import './FilterOptions.css';
import PracticeViewPicker from './PracticeViewPicker';
import AssignedPracticeFilter from './AssignedPracticeFilter/AssignedPracticeFilter';
import FilterButtons from './FilterButtons/FilterButtons';
import TextSearchCollapser from './TextSearchCollapser/TextSearchCollapser';
import hasPermission from '../../Shared/hasPermission';

const FilterOptions = ({ onSearchOpen }) => {
    // bool tied to the filter assigned practices button
    const onlyShowAssigned = useSelector(state => state.practice.onlyShowAssigned);
    const permissions = useSelector((state) => state.auth.permissions, shallowEqual);
    const can = (permission) => hasPermission(permission, permissions);
    const canAssignUsers = can(`Assignment`);
    
    return (
        <div id="filterOptions">

            <div className="my-3">
                {onlyShowAssigned ? canAssignUsers && <AssignedPracticeFilter /> : <PracticeViewPicker />}
            </div>

            <FilterButtons />

            {/* TODO: stop prop drilling this on search open function */}
            {/* because OnSearhOpen needs to fire on collapse, I did not conditionally render this */}
            <TextSearchCollapser onSearchOpen={onSearchOpen} />

            <div className="pt-3 px-5"></div>
        </div>
    );
};

export default React.memo(FilterOptions);
  